<div class="row" style="border-bottom: 1px solid rgba(0, 0, 0, 0.1); background-color: #295281">
  <div class="logo">
    <img src="assets/logo/logo-white.png" *ngIf="me() && !me()?.logo_url" />
    <img [src]="me()?.logo_url" *ngIf="me() && me()?.logo_url" style="border-radius: 26px" />
  </div>
  <div class="top-nav" [class.tsmode]="users.isTemporaryLogin()">
    <div class="title">
      <div style="font-size: 12px">
        {{ getDealerName()
        }}<span style="color: #fca503; font-weight: 500; margin: 0 14px">{{
          users.isTemporaryLogin() ? "Technical Support Session" : ""
        }}</span
        ><span *ngIf="dealerService?.isSoftBlock && users.isTemporaryLogin()" style="margin-right: 14px"
          >Soft Block</span
        >
      </div>
      <div class="id-badge">ID : {{ getDealerId() }}</div>
      <div
        class="badge-container"
        *ngIf="isADCLinked"
        (mouseenter)="isShowADCLinkTooltip = true"
        (mouseleave)="isShowADCLinkTooltip = false"
        style="position: relative; height: 27px; display: flex; align-items: center"
      >
        <div class="linked-badge ADC">ADC Linked</div>
        <div class="link-tooltip" *ngIf="isShowADCLinkTooltip">
          <div class="tooltip-header">
            <div class="sync-background">
              <div class="logo-container">
                <div class="logo-background"><img src="assets/logo/chekt_app_icon.png" /></div>
                <div>CHeKT</div>
              </div>
              <div>↔</div>
              <div class="logo-container">
                <div class="logo-background adc"><img src="assets/logo/adc_logo.png" /></div>
                <div>ADC</div>
              </div>
            </div>
          </div>
          <div class="tooltip-info">
            <div style="margin-bottom: 4px">
              <span style="color: #55647b">CHeKT Dealer ID: </span><span>&nbsp;{{ getDealerId() }}</span>
            </div>
            <div style="margin-bottom: 4px; display: flex; flex-direction: row">
              <span class="external-id" style="color: #55647b; white-space: nowrap">Alarm.com Dealer ID: </span
              ><span>&nbsp;{{ exp_adc[0].external_dealer_id }}</span>
            </div>
            <div *ngIf="getPartnerConnectedByEmail()" style="display: flex; flex-direction: row">
              <span style="color: #55647b; white-space: nowrap">Linked by: </span
              ><span>&nbsp;{{ exp_adc[0].partner_connected_by_email }}</span>
            </div>
          </div>
        </div>
      </div>
      <div
        class="badge-container"
        *ngIf="isOELinked"
        (mouseenter)="isShowOELinkTooltip = true"
        (mouseleave)="isShowOELinkTooltip = false"
        style="position: relative; height: 27px; display: flex; align-items: center"
      >
        <div class="linked-badge OE">OE Linked</div>
        <div class="link-tooltip" *ngIf="isShowOELinkTooltip">
          <div class="tooltip-header">
            <div class="sync-background">
              <div class="logo-container">
                <div class="logo-background"><img src="assets/logo/chekt_app_icon.png" /></div>
                <div>CHeKT</div>
              </div>
              <div>↔</div>
              <div class="logo-container">
                <div class="logo-background oe"><img src="assets/logo/oe_logo.png" /></div>
                <div>OE</div>
              </div>
            </div>
          </div>
          <div class="tooltip-info">
            <div style="margin-bottom: 4px; display: flex">
              <span style="color: #55647b">CHeKT Dealer ID: </span><span>&nbsp;{{ getDealerId() }}</span>
            </div>
            <div
              *ngFor="let item of exp_oe; let i = index"
              style="margin-bottom: 8px; display: flex; flex-direction: column"
            >
              <div class="oe-container">
                <div class="oe-divider"></div>
              </div>
              <div style="margin-bottom: 4px; display: flex; flex-direction: row">
                <span class="external-id" style="color: #55647b; white-space: nowrap">OpenEye CP ID:</span
                ><span style="white-space: nowrap">&nbsp;{{ item.external_dealer_id }}</span>
              </div>
              <div style="margin-bottom: 4px; display: flex; flex-direction: row">
                <span class="external-id" style="color: #55647b; white-space: nowrap">OpenEye CP Name:</span
                ><span style="white-space: nowrap">&nbsp;{{ item?.name || "No Name" }}</span>
              </div>
              <div style="display: flex; flex-direction: row">
                <span style="color: #55647b; white-space: nowrap">Linked by:</span
                ><span>&nbsp;{{ item?.partner_connected_by_email || "No Email" }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div [class]="computedDealerPlan()" (click)="goToDealerPlanDescription()">{{ dealerPlan || "Basic" }}</div>
      <div
        class="--g-tooltip-content"
        *ngIf="isShowDowngradeWarning"
        (mouseenter)="commonService.setTooltipPosition($event, 'bottom-center')"
      >
        <comp-icon class="--g-tooltip-icon" [icon]="'info'" [size]="16" [color]="'white'"></comp-icon>
        <div class="--g-tooltip" style="text-align: center; font-size: 12px">
          Account Scheduled for Downgrade Next Month:<br />{{ nextDealerPlan }}
        </div>
      </div>
    </div>
    <div class="env-switcher" *ngIf="isLocalHost">
      <div class="env-button" *ngFor="let env of envs" (click)="setEnv(env)" [class.active]="currentEnv === env">
        {{ env }}
      </div>
    </div>
    <div class="tool-container" #noticeSelect>
      <div class="tool" (click)="isOpenNotiMenu = !isOpenNotiMenu" [class.tool-icon-active]="isOpenNotiMenu">
        <i class="material-icons-outlined" style="font-size: 24px; color: white">notifications</i>
        <div class="tool-menu noti" *ngIf="!isReadAllNotice"></div>
      </div>
      <div class="notification" *ngIf="isOpenNotiMenu">
        <div
          class="notification-item selected"
          [ngClass]="isReadNoticeList['automation-rules'] ? 'notification-item' : 'notification-item selected'"
          (click)="goToNoticeDescription('automation-rules')"
        >
          <div style="display: flex; justify-content: space-between">
            <div class="noti-title">Automation Rules</div>
            <div class="timestamp">Nov 29, 2022</div>
          </div>
          <div class="path">🚀 Customers > Site Details > Automation Rules</div>
          <div class="description">Build automated actions to enhance the security services for your customers.</div>
        </div>
        <hr style="height: 1px; margin: 0; border: 0; background: #e6e6e6" />
        <div
          class="notification-item selected"
          [ngClass]="
            isReadNoticeList['video-storage-and-cloud-api'] ? 'notification-item' : 'notification-item selected'
          "
          (click)="goToNoticeDescription('video-storage-and-cloud-api')"
        >
          <div style="display: flex; justify-content: space-between">
            <div class="noti-title">Extend Cloud Video Storage & CHeKT Cloud API</div>
            <div class="timestamp">Jan 17, 2023</div>
          </div>
          <div class="path">🚀 Settings > API Keys</div>
          <div class="description">
            Extend video storage with dealer plan changes, and enjoy integration of 3rd party software systems.
          </div>
        </div>
        <hr style="height: 1px; margin: 0; border: 0; background: #e6e6e6" />
        <div
          class="notification-item selected"
          [ngClass]="isReadNoticeList['cloud-ai'] ? 'notification-item' : 'notification-item selected'"
          (click)="goToNoticeDescription('cloud-ai')"
        >
          <div style="display: flex; justify-content: space-between">
            <div class="noti-title">CHeKT Cloud AI Filtering</div>
            <div class="timestamp">May 23, 2023</div>
          </div>
          <div class="path">🚀 Settings > AI Filtering</div>
          <div class="description">Turn on AI filtering and turn down the XML signal.</div>
        </div>
      </div>
    </div>
    <div style="position: relative; margin: 0 8px">
      <input
        class="search"
        autocomplete="off"
        type="text"
        placeholder="Search"
        [(ngModel)]="search_text"
        (keyup)="searchEvent()"
        (focus)="focusSearch()"
        [style.width.px]="search_width"
        #search
      />
      <div class="search-result" *ngIf="search_width > 160" [class.has-border]="search_text?.length" #searcher>
        <div class="top-search-list" style="color: #777; white-space: pre-line" *ngIf="searchMsg !== ''">
          {{ searchMsg }}
        </div>
        <div
          class="top-search-list search-title"
          (click)="toggleSection('sites')"
          *ngIf="searched_sites.length > 0"
          style="position: relative"
        >
          Sites ({{ searched_sites.length }})
          <comp-icon
            class="expand-icon"
            [class.reverse]="!sectionVisible.sites"
            [icon]="'expend_more'"
            [size]="'20'"
            [color]="'#000'"
            style="position: absolute; right: 10px"
          ></comp-icon>
        </div>
        <div *ngIf="sectionVisible.sites">
          <div class="top-search-list has-child" *ngFor="let site of searched_sites" (click)="gotoSites(site)">
            <div style="display: inline-block; vertical-align: middle">
              {{ site.name }}<br /><span style="font-size: 10px; color: #777" *ngIf="site.customer_account_number"
                >&#35;{{ site.customer_account_number }} | </span
              ><span style="font-size: 10px; color: #777" *ngIf="site.address1 || site.address2">{{
                site.address1 || site.address2
              }}</span>
            </div>
          </div>
        </div>
        <div
          class="top-search-list search-title"
          (click)="toggleSection('users')"
          *ngIf="searched_users.length > 0"
          style="position: relative"
        >
          Users ({{ searched_users.length }})
          <comp-icon
            class="expand-icon"
            [class.reverse]="!sectionVisible.users"
            [icon]="'expend_more'"
            [size]="'20'"
            [color]="'#000'"
            style="position: absolute; right: 10px"
          ></comp-icon>
        </div>
        <div *ngIf="sectionVisible.users">
          <div class="top-search-list has-child" *ngFor="let user of searched_users" (click)="gotoUsers(user)">
            <img
              class="face"
              *ngIf="user.provider_picture"
              [src]="user.provider_picture"
              (error)="user.provider_picture = null"
            />
            <div class="no-face" *ngIf="!user.provider_picture">
              <div style="padding-top: 8px">{{ user.email ? user.email.slice(0, 1) : user.email }}</div>
            </div>
            {{ commonService.getFullName(user) }}
          </div>
        </div>
        <div
          class="top-search-list search-title"
          (click)="toggleSection('devices')"
          *ngIf="searched_devices.length > 0"
          style="position: relative"
        >
          Devices ({{ searched_devices.length }})
          <comp-icon
            class="expand-icon"
            [class.reverse]="!sectionVisible.devices"
            [icon]="'expend_more'"
            [size]="'20'"
            [color]="'#000'"
            style="position: absolute; right: 10px"
          ></comp-icon>
        </div>
        <div *ngIf="sectionVisible.devices">
          <div
            class="top-search-list has-child"
            *ngFor="let device of searched_devices"
            (click)="gotoDevices(device)"
            style="position: relative"
          >
            <div class="icon">
              <i class="material-icons" *ngIf="device.type != 11" style="color: #55647b">videocam</i>
              <div class="svg-icon" *ngIf="device.type == 11">
                <svg fill="#55647B" width="24px" height="24px" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <rect x="3" y="4" width="18" height="18"></rect>
                  <rect x="15" y="2" width="4" height="3"></rect>
                  <rect fill="#FFFFFF" x="6" y="16" width="12" height="3"></rect>
                </svg>
              </div>
            </div>
            <div style="display: inline-block; vertical-align: middle">
              <div>{{ device.name }}</div>
              <div style="font-size: 10px; color: #777">{{ device.mac }}</div>
            </div>
            <div class="site-name">{{ device.site_name }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="tool-container" #helpSelect>
      <div class="tool" (click)="toggleHelpMenu()" [class.tool-icon-active]="isOpenHelpMenu">
        <comp-icon [icon]="'help'" [size]="24" [color]="'white'"></comp-icon>
      </div>
      <div class="tool-menu help" *ngIf="isOpenHelpMenu">
        <div class="menu-item" (click)="goToDocPage()">Support KB</div>
        <div class="menu-item" (click)="showSalesIQModal()">Chat with us</div>
        <div class="menu-item" (mouseenter)="isShowVideos = !isShowVideos">Overview Videos</div>
      </div>
      <div class="sub-tool-menu help" *ngIf="isShowVideos">
        <div class="menu-item" (click)="gotoDPOverViewVideo()">
          <div>Dealer Portal Overview</div>
          <i class="material-icons" style="font-size: 16px; color: #1e90ff">open_in_new</i>
        </div>
        <div class="menu-item" (click)="gotoHowToAddSite()">
          <div>How to add a customer site</div>
          <i class="material-icons" style="font-size: 16px; color: #1e90ff">open_in_new</i>
        </div>
        <div class="menu-item" (click)="gotoHowToAddBridge()">
          <div>How to add a CHeKT Bridge</div>
          <i class="material-icons" style="font-size: 16px; color: #1e90ff">open_in_new</i>
        </div>
        <div class="menu-item" (click)="gotoHowToAddCam()">
          <div>How to add CHeKT Cameras and Speakers</div>
          <i class="material-icons" style="font-size: 16px; color: #1e90ff">open_in_new</i>
        </div>
      </div>
    </div>
    <div class="profile-button" *ngIf="me()?.provider_picture" (click)="m_profile.open()">
      <img class="profile" [src]="me()?.provider_picture" />
    </div>
  </div>
</div>
<dealer-profile [modal]="m_profile"></dealer-profile>
<dealer-plan-modal
  *ngIf="m_dealer_plan_modal.is_active"
  [modal]="m_dealer_plan_modal"
  (onClose)="onCloseDealerPlanModal($event)"
></dealer-plan-modal>
